import React from 'react';
import { CheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { getImage } from '../data/images';
import { Reveal } from './Reveal';
const FEATURES = [{
  en: 'Fully furnished',
  es: 'Completamente amoblada'
}, {
  en: 'Open-concept floor plan',
  es: 'Plano de concepto abierto'
}, {
  en: 'Bright modern interiors',
  es: 'Interiores modernos y luminosos'
}, {
  en: 'Water and pond views',
  es: 'Vista al agua y al estanque'
}, {
  en: 'Three bedrooms',
  es: 'Tres habitaciones'
}, {
  en: 'Two full bathrooms',
  es: 'Dos baños completos'
}, {
  en: 'One half bathroom',
  es: 'Un medio baño'
}, {
  en: 'One-car attached garage',
  es: 'Garaje adjunto para un vehículo'
}, {
  en: 'Kitchen appliances included',
  es: 'Electrodomésticos incluidos'
}, {
  en: 'Washer and dryer included',
  es: 'Lavadora y secadora incluidas'
}, {
  en: 'Built in 2023',
  es: 'Construida en 2023'
}, {
  en: 'Corner-unit positioning',
  es: 'Ubicación de esquina'
}];
export function DescriptionSection() {
  const {
    lang,
    t
  } = useLanguage();
  const kitchen = getImage('kitchenIsland');
  return <section className="w-full bg-white py-20 lg:py-28" data-id="element-170" data-mp="1duf76j9s5ijr">
      <div className="mx-auto max-w-editorial px-5 lg:px-8" data-id="element-171" data-mp="18wddl4eqa0u1">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-172" data-mp="18wvg2irzhbae">
          <div className="lg:col-span-6" data-id="element-173" data-mp="13y22kqcp5ka8">
            <Reveal data-id="element-174" data-mp="13z3pbs32rv7s">
              <p className="label-caps text-gold" data-id="element-175" data-mp="13vfzb2wu9qxt">{t('Welcome Home', 'Bienvenido a Casa')}</p>
              <h2 className="mt-5 max-w-[18ch] font-display text-[34px] font-semibold uppercase leading-[1.02] text-midnight sm:text-[44px] lg:text-[52px]" data-id="element-176" data-mp="21iophb7sbo65">
                {t('Designed for Easy Living', 'Diseñada para Disfrutar')}
              </h2>
              <div className="gold-rule mt-7 w-24" data-id="element-177" data-mp="1mmqmb8zg1jkf" />
              <p className="mt-7 text-[15px] leading-relaxed text-ink/80 lg:text-base" data-id="element-178" data-mp="1mq4qmmro42ui">
                {t('Welcome to 1039 Plantation Ln, a beautifully furnished water-view townhome in Davenport, Florida. Built in 2023, this bright and inviting property offers an open-concept layout designed for comfortable everyday living, memorable Florida vacations and effortless entertaining.', 'Bienvenido a 1039 Plantation Ln, una hermosa townhome amoblada con vista al agua en Davenport, Florida. Construida en 2023, esta propiedad luminosa y acogedora ofrece una distribución abierta, diseñada para una vida cómoda, vacaciones inolvidables en Florida y momentos especiales con familiares e invitados.')}
              </p>
              <p className="mt-5 text-[15px] leading-relaxed text-ink/80 lg:text-base" data-id="element-179" data-mp="2kikqzybv8e4g">
                {t('The property is being offered fully furnished, allowing its new owner to begin enjoying the home without the time and expense of furnishing every room.', 'La propiedad se ofrece completamente amoblada, permitiendo que su nuevo propietario comience a disfrutarla sin el tiempo y el gasto de amoblar cada espacio.')}
              </p>
            </Reveal>

            <Reveal delay={0.06} data-id="element-180" data-mp="1i6tfb45r10ay">
              <ul className="mt-10 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-181" data-mp="1e3wowr9yvzwg">
                {FEATURES.map(feature => <li key={feature.en} className="flex items-start gap-3 text-[14px] text-ink/85" data-id="element-182" data-mp="1s47med5s8cql">
                    <CheckIcon className="mt-[3px] h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-183" data-mp="1n31sic0dyjfh" />
                    <span data-id="element-184" data-mp="212jiuvtby4qy">{lang === 'en' ? feature.en : feature.es}</span>
                  </li>)}
              </ul>
            </Reveal>
          </div>

          <div className="lg:col-span-6" data-id="element-185" data-mp="2ate35un0mu9r">
            <Reveal delay={0.08} data-id="element-186" data-mp="2at5sm9ed811q">
              {kitchen && <figure className="arch-frame-soft h-[420px] w-full sm:h-[520px] lg:h-[680px]" data-id="element-187" data-mp="25u2p4te1a2vv">
                  <img src={kitchen.src} alt={lang === 'en' ? kitchen.altEn : kitchen.altEs} width={kitchen.width} height={kitchen.height} loading="lazy" decoding="async" className="h-full w-full object-cover" style={{
                objectPosition: kitchen.objectPosition
              }} data-id="element-188" data-mp="2krbtcnofr150" />
                </figure>}
            </Reveal>
          </div>
        </div>
      </div>
    </section>;
}